
import { Participant } from "@/api/dtos";
import useParticipantNotesAndQueries from "@/hooks/data/useParticipantNotesAndQueries";
import useParticipantSourceDataEventStatuses from "@/hooks/data/useParticipantSourceDataEventStatuses";
import useParticipants from "@/hooks/data/useParticipants";
import useSourceData from "@/hooks/data/useSourceData";
import { createContext } from "react"

export interface IParticipantNotesAndQueriesContext extends ReturnType<typeof useParticipantNotesAndQueries> {
}

export const ParticipantNotesAndQueriesContext = createContext<IParticipantNotesAndQueriesContext>({
    data: undefined,
    itemMap: {},
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ParticipantNotesAndQueriesContext;